import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    Spin,
    Select,
    DatePicker,
    Checkbox,
    Form,
    Input,
    Button,
    Table,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
    getGenderCategory
} from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action";
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import { getStyle, getStyleChange } from "../../redux/actions/style";
import { getFabric } from "../../redux/actions/fabric.action";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import jsPDF from "jspdf";
import { getNetShippedInventory } from "../../redux/actions/netShippedInventory.action";

const dateFormatList = ["MM-DD-YYYY"];

const NetShippedInventory = ({ token }) => {
    TabTitle("Net Shipped + Inventory");
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {
        style,
        getWiseStockReport,
        gender,
        genderCategory,
        season,
        productStatus,
        wash,
        genderCategoryChange,
        styleChange,
        Sku,
        seasonYear,
        fabric,
        netShippedInventory
    } = useSelector((state) => state);
    const menuId = ReadCookie("menuId");
    const userName = ReadCookie("name");
    const tableRef = useRef(null);
    const [isChecked, setIsChecked] = useState([]);
    const [isChecked2, setIsChecked2] = useState([]);
    const [allSesion, setAllSesion] = useState(true);
    const [allStatus, setAllStatus] = useState(true);
    const [isPCChecked, setIsPCChecked] = useState([]);
    const [allPC, setAllPC] = useState(true);
    const [loading, setLoading] = useState(false);
    const [BgradeCheck, setBgradeCheck] = useState(false);
    const [data, setData] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const location = useLocation();

    const [genderName, setGenderName] = useState(null);
    const [seasonName, setSeasonName] = useState(null);
    const [yearName, setYearName] = useState(null);
    const [CatergoryName, setCatergoryName] = useState(null);
    const [sku, setSKU] = useState(null);
    const [styleName, setStyleName] = useState(null);
    const [washName, setWashName] = useState(null);
    const [fabricName, setFabricName] = useState(null);
    const [sortedInfo, setSortedInfo] = React.useState({});
    const [shouldDownload, setShouldDownload] = useState(false);
    const csvLinkRef = useRef(null);

    const initialDate = moment();



    const values = {
        item_id: null,
        location_id: null,
    };

    const { Option } = Select;
    let pendingDate = "";

    const onChangeDate = (date, dateString) => {
        pendingDate = dateString;
    };

    const sesionSelectAll = (e) => {
        setAllSesion(e.target.checked);
    };
    const statusSelectAll = (e) => {
        setAllStatus(e.target.checked);
    };



    const isCheckboxChecked2 = (id, value) => {
        const filterCheckBox =
            productStatus &&
            productStatus?.payload?.data.find((val) => val.product_status_id === id);
        const checkId = isChecked2.includes(id);
        if (!checkId) {
            setIsChecked2((current) => [
                ...current,
                filterCheckBox.product_status_id,
            ]);
        }
        if (!value) {
            const removeUnCheck = isChecked2.filter(
                (item) => item !== filterCheckBox.product_status_id
            );
            setIsChecked2(removeUnCheck);
        }
        setAllStatus(false);
    };

    useEffect(() => {
        if (location?.state && location?.state?.values?.new_season_id) {
            const values = {
                as_on_date: initialDate,
                sku: "",
                season_id: location?.state?.values?.new_season_id,
                gender_id: location?.state?.values?.gender_id,
                gender_category_id: null,
                fit_category_id: null,
                style_id: null,
                product_status_id: null,
                product_class_id: null,
                sort_on: null,
                include_bgrade: "abc",
                wash_id: null,
                new_season_year_id: null,
            };
            form.setFieldsValue({
                season_id: values.season_id,
                gender_id: values.gender_id,
            });
            setLoading(true);
            dispatch(
                getNetShippedInventory(
                    token,
                    values,
                    isChecked,
                    isChecked2,
                    isPCChecked,
                    BgradeCheck
                )
            ).then((res) => {
                setLoading(false);
                setData(res?.payload?.data);
                downloadExcelFileData(res?.payload?.data);
            });
        }
    }, [location?.state && location?.state?.values?.new_season_id]);

    const onFinish = async (e) => {
        setLoading(true);
        await form.validateFields().then((values) => {
            dispatch(
                getNetShippedInventory(
                    token,
                    values,
                    isChecked,
                    isChecked2,
                    isPCChecked,
                    BgradeCheck
                )
            ).then((res) => {
                setLoading(false);
                setData(res?.payload?.data);
                downloadExcelFileData(res?.payload?.data);
            });
        });
    };

    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v, i) => {
                return {
                    "SNO": i + 1,
                    "Gender": v.gender,
                    "Current Season": v.current_season,
                    "Sku": v.item_code,
                    "Inseam": v.inseam,
                    "Style": v.style,
                    "Wash": v.wash,
                    "Fabric": v.fabric,
                    "Fit Category": v.fit_category,
                    "Ship Quantity": numeral(v.ship_quantity).format('0,0'),
                    "Ship Amount": "$" + numeral(v.ship_amount).format('0,0.00'),
                    "Return Quantity": numeral(v.return_quantity).format('0,0'),
                    "Return Amount": "$" + numeral(v.return_amount).format('0,0.00'),
                    "Net Quantity": numeral(v.net_quantity).format('0,0'),
                    "Net Amount": "$" + numeral(v.net_amount).format('0,0.00'),
                    
                    "BERGEN": numeral(v.bergan).format('0,0'),
                    "TRNS": numeral(v.transit).format('0,0'),
                    "PK": numeral(v.pakistan).format('0,0'),
                    "PROD": numeral(v.production).format('0,0'),
                    "PEND": numeral(v.pending).format('0,0'),
                    "INT": numeral(v.international).format('0,0'),
                    "OTS": numeral(v.ots).format('0,0'),
                    // "ECOM": numeral(v.ecommerce).format('0,0'),
                    // "D2C": numeral(v.d2c).format('0,0'),
                    "POD": numeral(v.pod).format('0,0'),
                };
            })
        );
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);
    };

    const getSortedData = (data, sortedInfo) => {
        if (!sortedInfo.order) return data;

        const { columnKey, order } = sortedInfo;
        return [...data].sort((a, b) => {
            const aValRaw = a[columnKey];
            const bValRaw = b[columnKey];

            const aVal = Number(
                typeof aValRaw === "string"
                    ? aValRaw.replace(/,/g, "")
                    : aValRaw
            );
            const bVal = Number(
                typeof bValRaw === "string"
                    ? bValRaw.replace(/,/g, "")
                    : bValRaw
            );

            if (isNaN(aVal)) return 1;
            if (isNaN(bVal)) return -1;

            if (order === "ascend") {
                return aVal - bVal;
            } else {
                return bVal - aVal;
            }
        });
    };

    const handleExport = () => {

        const sortedData = getSortedData(data, sortedInfo);


        const mappedData = sortedData?.map((v, i) => ({
            "SNO": i + 1,
            "Gender": v.gender,
            "Current Season": v.current_season,
            "Sku": v.item_code,
            "Inseam": v.inseam,
            "Style": v.style,
            "Wash": v.wash,
            "Fabric": v.fabric,
            "Fit Category": v.fit_category,
            "Ship Quantity": numeral(v.ship_quantity).format('0,0'),
            "Ship Amount": "$" + numeral(v.ship_amount).format('0,0.00'),
            "Return Quantity": numeral(v.return_quantity).format('0,0'),
            "Return Amount": "$" + numeral(v.return_amount).format('0,0.00'),
            "Net Quantity": numeral(v.net_quantity).format('0,0'),
            "Net Amount": "$" + numeral(v.net_amount).format('0,0.00'),
      
            "BERGEN": numeral(v.bergan).format('0,0'),
            "TRNS": numeral(v.transit).format('0,0'),
            "PK": numeral(v.pakistan).format('0,0'),
            "PROD": numeral(v.production).format('0,0'),
            "PEND": numeral(v.pending).format('0,0'),
            "INT": numeral(v.international).format('0,0'),
            "OTS": numeral(v.ots).format('0,0'),
            // "ECOM": numeral(v.ecommerce).format('0,0'),
            // "D2C": numeral(v.d2c).format('0,0'),
            "POD": numeral(v.pod).format('0,0'),
        }));

        setExcelData(mappedData);
        setShouldDownload(true);
    };

    const prepareExcelData = () => {
        const sortedData = getSortedData(data, sortedInfo);

        const mappedData = sortedData.map(item => {
            const obj = {};
            columns.forEach(col => {
                const key = col.title || col.dataIndex;
                const dataIndex = col.dataIndex;
                if (col.exportRender) {
                    obj[key] = col.exportRender(item[dataIndex]);
                } else {
                    obj[key] = item[dataIndex];
                }
            });
            return obj;
        });

        setExcelData(mappedData);
    };

    useEffect(() => {
        if (shouldDownload && excelData.length > 0) {
            if (csvLinkRef.current && csvLinkRef.current.link) {
                csvLinkRef.current.link.click();
                setShouldDownload(false);
            }
        }
    }, [shouldDownload, excelData]);


    function generatePDF() {
        var doc = new jsPDF({ orientation: 'landscape' });

        var columns = [
            "#", "Gender", "Current Season", "SKU", "Inseam", "Style", "Wash", "Fabric", "Fit Category",
            "Ship Quantity", "Ship Amount", "Return Quantity", "Return Amount", "Net Quantity",
            "Net Amount", "BERGEN", "TRNS", "PK", "PROD", "PEND", "INT", "OTS", "POD"
        ];

        var rows = [];
        const sortedData = getSortedData(data, sortedInfo);
        sortedData.forEach((item, index) => {
            var row = [
                index + 1,  // Serial No
                item.gender,
                item.current_season,
                item.item_code,
                item.inseam,
                item.style,
                item.wash,
                item.fabric,
                item.fit_category,
                numeral(item.ship_quantity).format('0,0'),                    // Ship Quantity
                "$" + numeral(item.ship_amount).format('0,0.00'),                // Ship Amount
                numeral(item.return_quantity).format('0,0'),                  // Return Quantity
                "$" + numeral(item.return_amount).format('0,0.00'),              // Return Amount
                numeral(item.net_quantity).format('0,0'),                     // Net Quantity
                "$" + numeral(item.net_amount).format('0,0.00'),                 // Net Amount
                numeral(item.bergan).format('0,0'),                           // BERGEN
                numeral(item.transit).format('0,0'),                          // TRNS
                numeral(item.pakistan).format('0,0'),                         // PK
                numeral(item.production).format('0,0'),                       // PROD
                numeral(item.pending).format('0,0'),                          // PEND
                numeral(item.international).format('0,0'),                    // INT
                numeral(item.ots).format('0,0'),                              // OTS
                // numeral(item.ecommerce).format('0,0'),                        // ECOM
                // numeral(item.d2c).format('0,0'),                              // D2C
                numeral(item.pod).format('0,0')                               // POD
            ];
            rows.push(row);
        });

        const totals = netShippedInventory?.payload?.data.reduce((acc, item) => {
            const fields = [
                "ship_quantity", "ship_amount", "return_quantity", "return_amount",
                "net_quantity", "net_amount", "bergan", "transit", "pakistan",
                "production", "pending", "international", "ots",  "pod"
            ];
            fields.forEach(field => {
                acc[field] = (acc[field] || 0) + parseFloat(item[field] || 0);
            });
            return acc;
        }, {});

        Object.keys(totals).forEach(key => {
            totals[key] = numeral(totals[key]).format('0');
        });

        rows.push([
            " ", " ", " ", " ", " ", " ", " ", " ", "Total:",
            numeral(totals.ship_quantity).format('0,0'),
            "$" + numeral(totals.ship_amount).format('0,0'),
            numeral(totals.return_quantity).format('0,0'),
            "$" + numeral(totals.return_amount).format('0,0'),
            numeral(totals.net_quantity).format('0,0'),
            "$" + numeral(totals.net_amount).format('0,0'),
            numeral(totals.bergan).format('0,0'),
            numeral(totals.transit).format('0,0'),
            numeral(totals.pakistan).format('0,0'),
            numeral(totals.production).format('0,0'),
            numeral(totals.pending).format('0,0'),
            numeral(totals.international).format('0,0'),
            numeral(totals.ots).format('0,0'),
            // numeral(totals.ecommerce).format('0,0'),
            // numeral(totals.d2c).format('0,0'),
            numeral(totals.pod).format('0,0')
        ]);

        doc.autoTable({
            head: [columns],
            body: rows,
            styles: {
                fontSize: 4.5,
                halign: 'left'
            },
            margin: { right: 2, left: 4 },
            columnStyles: {
                0: { cellWidth: 10 },   // Serial No
                1: { cellWidth: 10 },   // Gender
                2: { cellWidth: 12 },   // Current Season
                3: { cellWidth: 10 },   // SKU
                4: { cellWidth: 9 },    // Inseam
                5: { cellWidth: 20 },   // Style
                6: { cellWidth: 20 },   // Wash
                7: { cellWidth: 21 },   // Fabric
                8: { cellWidth: 10 },   // Fit Category
                9: { cellWidth: 12, halign: 'right' },  // Ship Quantity
                10: { cellWidth: 12, halign: 'right' }, // Ship Amount
                11: { cellWidth: 12, halign: 'right' }, // Return Quantity
                12: { cellWidth: 12, halign: 'right' }, // Return Amount
                13: { cellWidth: 12, halign: 'right' }, // Net Quantity
                14: { cellWidth: 12, halign: 'right' }, // Net Amount
                15: { cellWidth: 10, halign: 'right' }, // BERGEN
                16: { cellWidth: 10, halign: 'right' },  // TRNS
                17: { cellWidth: 10, halign: 'right' },  // PK
                18: { cellWidth: 10, halign: 'right' },  // PROD
                19: { cellWidth: 9, halign: 'right' },  // PEND
                20: { cellWidth: 9, halign: 'right' },  // INT
                21: { cellWidth: 9, halign: 'right' },  // OTS
                // 22: { cellWidth: 9, halign: 'right' },  // ECOM
                // 23: { cellWidth: 9, halign: 'right' },  // D2C
                22: { cellWidth: 9, halign: 'right' }   // POD
            },
            didParseCell: function (data) {
                if (data.section === 'head') {
                    // Indexes of columns you want to right-align in header
                    const rightAlignedColumns = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
                    if (rightAlignedColumns.includes(data.column.index)) {
                        data.cell.styles.halign = 'right';
                    } else {
                        data.cell.styles.halign = 'left';
                    }
                }
            }
        });
        doc.save("Net-Shipped-Inventory.pdf");
    }



    useEffect(() => {
        dispatch(getStyle(token, menuId));
        dispatch(getProductType(token, values));
        dispatch(getGenderCategory(token, menuId));
        dispatch(getSeason(token, menuId));
        dispatch(getProductStatus(token, menuId));
        dispatch(getProductClass(token, menuId));
        dispatch(getSize(token, menuId));
        dispatch(getGender(token, menuId));
        dispatch(getFitCategory(token, menuId));
        dispatch(getWashName(token, menuId));
        dispatch(getSeasonYear(token, menuId));
        dispatch(getFabric(token, menuId))
    }, [dispatch, menuId, token]);

    useEffect(() => {
        if (allSesion) {
            setIsChecked([]);
        }
    }, [allSesion]);

    useEffect(() => {
        if (allStatus) {
            setIsChecked2([]);
        }
    }, [allStatus]);

    useEffect(() => {
        if (allPC) {
            setIsPCChecked([]);
        }
    }, [allPC]);

    const handlePrint = () => {
        window.print();
    };


    const columns = [
        {
            title: "#",
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: "Gender",
            dataIndex: "gender",
            key: "gender",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.gender !== null) {
                    return record.gender
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.gender !== null) & (b.gender !== null)) {
                    return a.gender.localeCompare(b.gender);
                }
            },
        },
        {
            title: "Current Season",
            dataIndex: "current_season",
            key: "current_season",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.current_season !== null) {
                    return record.current_season
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.current_season !== null) & (b.current_season !== null)) {
                    return a.current_season.localeCompare(b.current_season);
                }
            },
        },
        {
            title: "SKU",
            dataIndex: "item_code",
            key: "item_code",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.item_code !== null) {
                    return record.item_code
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.item_code !== null) & (b.item_code !== null)) {
                    return a.item_code - b.item_code;
                }
            },
        },
        {
            title: "Inseam",
            dataIndex: "inseam",
            key: "inseam",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.inseam !== null) {
                    return record.inseam
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.inseam !== null) & (b.inseam !== null)) {
                    return a.inseam - b.inseam;
                }
            },
        },
        {
            title: "Style",
            dataIndex: "style",
            key: "style",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.style !== null) {
                    return record.style
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.style !== null) & (b.style !== null)) {
                    return a.style.localeCompare(b.style);
                }
            },
        },
        {
            title: "Wash",
            dataIndex: "wash",
            key: "wash",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.wash !== null) {
                    return record.wash
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.wash !== null) & (b.wash !== null)) {
                    return a.wash.localeCompare(b.wash);
                }
            },
        },
        {
            title: "Fabric",
            dataIndex: "fabric",
            key: "fabric",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.fabric !== null) {
                    return record.fabric
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.fabric !== null) & (b.fabric !== null)) {
                    return a.fabric.localeCompare(b.fabric);
                }
            },
        },
        {
            title: "Fit Category",
            dataIndex: "fit_category",
            key: "fit_category",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220 w-100"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.fit_category !== null) {
                    return record.fit_category
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.fit_category !== null) & (b.fit_category !== null)) {
                    return a.fit_category.localeCompare(b.fit_category);
                }
            },
        },
        {
            title: "Net Ship",
            children: [
                {
                    title: "Ship Quantity",
                    dataIndex: "ship_quantity",
                    key: "ship_quantity",
                    render: (text, record, index) => {
                        return `${numeral(text).format('0,0')}`;
                    },
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.ship_quantity !== null) {
                            return record.ship_quantity
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.ship_quantity !== null) & (b.ship_quantity !== null)) {
                            return a.ship_quantity - b.ship_quantity;
                        }
                    },
                },
                {
                    title: "Ship Amount",
                    dataIndex: "ship_amount",
                    key: "ship_amount",

                    align: "right",
                    render: (text, record, index) => {
                        return `$ ${numeral(text).format('0,0.00')}`;
                    },
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.ship_amount !== null) {
                            return record.ship_amount
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.ship_amount !== null) & (b.ship_amount !== null)) {
                            return a.ship_amount - b.ship_amount;
                        }
                    },
                },
                {
                    title: "Return Quantity",
                    dataIndex: "return_quantity",
                    key: "return_quantity",
                    render: (text, record, index) => {
                        return `${numeral(text).format('0,0')}`;
                    },
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.return_quantity !== null) {
                            return record.return_quantity
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.return_quantity !== null) & (b.return_quantity !== null)) {
                            return a.return_quantity - b.return_quantity;
                        }
                    },
                },
                {
                    title: "Return Amount",
                    dataIndex: "return_amount",
                    key: "return_amount",
                    render: (text, record, index) => {
                        return `$ ${numeral(text).format('0,0.00')}`;
                    },
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.return_amount !== null) {
                            return record.return_amount
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.return_amount !== null) & (b.return_amount !== null)) {
                            return a.return_amount - b.return_amount;
                        }
                    },
                },
                {
                    title: "Net Quantity",
                    dataIndex: "net_quantity",
                    key: "net_quantity",
                    render: (text, record, index) => {
                        return `${numeral(text).format('0,0')}`;
                    },
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.net_quantity !== null) {
                            return record.net_quantity
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.net_quantity !== null) & (b.net_quantity !== null)) {
                            return a.net_quantity - b.net_quantity;
                        }
                    },
                },
                {
                    title: "Net Amount",
                    dataIndex: "net_amount",
                    key: "net_amount",
                    render: (text, record, index) => {
                        return `$ ${numeral(text).format('0,0.00')}`;
                    },
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.net_amount !== null) {
                            return record.net_amount
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.net_amount !== null) & (b.net_amount !== null)) {
                            return a.net_amount - b.net_amount;
                        }
                    },
                },
            ]
        },
        {
            title: "Inventory",
            children: [
                {
                    title: "BERGEN",
                    dataIndex: "bergan",
                    key: "bergan",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.bergan !== null) {
                            return record.bergan
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.bergan !== null) & (b.bergan !== null)) {
                            return a.bergan - b.bergan;
                        }
                    },
                },
                {
                    title: "TRNS",
                    dataIndex: "transit",
                    key: "transit",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.transit !== null) {
                            return record.transit
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.transit !== null) & (b.transit !== null)) {
                            return a.transit - b.transit;
                        }
                    },
                },
                {
                    title: "PK",
                    dataIndex: "pakistan",
                    key: "pakistan",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.pakistan !== null) {
                            return record.pakistan
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.pakistan !== null) & (b.pakistan !== null)) {
                            return a.pakistan - b.pakistan;
                        }
                    },
                },
                {
                    title: "PROD",
                    dataIndex: "production",
                    key: "production",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.production !== null) {
                            return record.production
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.production !== null) & (b.production !== null)) {
                            return a.production - b.production;
                        }
                    },
                },
                {
                    title: "PEND",
                    dataIndex: "pending",
                    key: "pending",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.pending !== null) {
                            return record.pending
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.pending !== null) & (b.pending !== null)) {
                            return a.pending - b.pending;
                        }
                    },
                },
                {
                    title: "INT",
                    dataIndex: "international",
                    key: "international",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.international !== null) {
                            return record.international
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.international !== null) & (b.international !== null)) {
                            return a.international - b.international;
                        }
                    },
                },
                {
                    title: "OTS",
                    dataIndex: "ots",
                    key: "ots",

                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.ots !== null) {
                            return record.ots
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.ots !== null) & (b.ots !== null)) {
                            return a.ots - b.ots;
                        }
                    },
                },
              
                {
                    title: "POD",
                    dataIndex: "pod",
                    key: "pod",
                    align: "right",
                    filterDropdown: ({
                        setSelectedKeys,
                        selectedKeys,
                        confirm,
                        clearFilters,
                    }) => {
                        return (
                            <>
                                <Input
                                    allowClear
                                    autoFocus
                                    className="pop-search-gen pop-220 w-100"
                                    value={selectedKeys[0]}
                                    onChange={(e) => {
                                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                                        confirm({ closeDropdown: false });
                                    }}
                                    onPressEnter={() => {
                                        confirm();
                                    }}
                                    onBlur={() => {
                                        confirm();
                                    }}
                                />
                            </>
                        );
                    },
                    filterIcon: (filtered) =>
                        filtered ? <FilterFilled /> : <SearchOutlined />,
                    onFilter: (value, record) => {
                        if (record.pod !== null) {
                            return record.pod
                                .toString()
                                .toLowerCase()
                                .includes(value.toLowerCase());
                        }
                    },
                    sorter: (a, b) => {
                        if ((a.pod !== null) & (b.pod !== null)) {
                            return a.pod - b.pod;
                        }
                    },
                },
            ]
        }

    ];

    const shipQuantityTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.ship_quantity),
        0
    );
    const shipAmountTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.ship_amount),
        0
    );
    const returnQuantityTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.return_quantity),
        0
    );
    const returnAmountTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.return_amount),
        0
    );
    const netQuantityTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.net_quantity),
        0
    );
    const netAmountTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.net_amount),
        0
    );

    const bergenTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.bergan),
        0
    );
    const trnsTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.transit),
        0
    );
    const pkTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.pakistan),
        0
    );
    const prodTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.production),
        0
    );
    const pendTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.pending),
        0
    );
    const intTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.international),
        0
    );
    const otsTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.ots),
        0
    );
    // const ecomTotal = netShippedInventory?.payload?.data.reduce(
    //     (acc, item, index) => acc + parseFloat(item.ecommerce),
    //     0
    // );

    // const d2cTotal = netShippedInventory?.payload?.data.reduce(
    //     (acc, item, index) => acc + parseFloat(item.d2c),
    //     0
    // );
    const podTotal = netShippedInventory?.payload?.data.reduce(
        (acc, item, index) => acc + parseFloat(item.pod),
        0
    );


    function debounce(cb, delay = 1000) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                cb(...args);
            }, delay);
        };
    }

    const handleSkuSearch = () => {
        dispatch(getSku(token, null, null, null));
    };

    const optimizedFn = useCallback(debounce(handleSkuSearch), []);

    const filterProductStatusName = productStatus?.payload?.data?.filter(item => isChecked2.includes(item.product_status_id));


    return (
        <div className="header_class business_header_oms" id="card-pdf" >
            <div className="row justify-content-between business_class_oms distributor">
                <div className="col-3 d-flex align-items-start box-space">
                    <div className="logobrand">
                        <img id="ImgLogo" alt="logo" src={logo} />
                    </div>
                </div>

                <div className="col-4 box-space right-content-header text-right">
                    <div className=" d-flex justify-content-end">
                        <div className=" d-flex justify-content-end mr-8 printing_class">
                            <div className="print_icon printing_class">
                                <i
                                    onClick={handlePrint}
                                    id="Image1"
                                    title="Print"
                                    alt="Print"
                                    src={btnPrint}
                                    className="fa-solid fa-print"
                                ></i>
                            </div>
                            <div className="print_icon printing_class">
                                <input
                                    type="image"
                                    name="ImgExcel"
                                    alt="Export to excel"
                                    id="ImgExcel"
                                    title="Export to excel"
                                    src={xlsx}
                                    style={{ borderWidth: "0px", height: "14px" }}
                                    onClick={handleExport}
                                />
                                <CSVLink
                                    filename={"Net-Shipped-inventory.csv"}
                                    data={excelData}
                                    style={{ display: "none" }}
                                    ref={csvLinkRef}
                                    // onClick={() => { }}
                                    onClick={prepareExcelData}
                                >
                                    <input
                                        type="image"
                                        name="ImgExcel"
                                        alt="Export to excel"
                                        id="ImgExcel"
                                        title="Export to excel"
                                        src={xlsx}
                                        style={{ borderWidth: "0px", height: "14px" }}
                                    />
                                </CSVLink>
                            </div>
                            <div className="print_icon printing_class">
                                <input
                                    type="image"
                                    name="ImgPDF"
                                    alt="Export to PDF"
                                    id="ImgPDF"
                                    title="Export to PDF"
                                    src={pdf}
                                    onClick={generatePDF}
                                    style={{ borderWidth: "0px", height: "18px" }}
                                />
                            </div>


                        </div>
                        <span style={{ fontSize: "small", fontWeight: "bolder" }}>
                            Net shipped + inventory
                            <br />
                            Rpt # 489
                            <br />
                            <p className=" mb-0">Rpt # 001_V4</p>
                            Login as:{" "}
                            <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                                {userName}
                            </span>
                            <br />
                        </span>
                    </div>

                </div>
            </div>

            <div className="business_class_oms mb-2 distributor">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                    <div className="main_form row">
                        <div className="col-12">
                            <hr className="my-1" />
                            <div>
                                <label htmlFor="">Product Status</label>
                                <div className="checkboxes">
                                    <div className="checkbox_content">
                                        <Form.Item name="current_status_id" className=" mb-0">
                                            <Checkbox checked={allStatus} onChange={statusSelectAll}>
                                                All
                                            </Checkbox>
                                        </Form.Item>
                                    </div>
                                    {productStatus &&
                                        productStatus?.payload?.data.map((it, index) => {
                                            return (
                                                <div key={index} className="checkbox_content">
                                                    <Form.Item name="current_status_id">
                                                        <Checkbox
                                                            checked={
                                                                allStatus
                                                                    ? false
                                                                    : isChecked2.includes(it.product_status_id)
                                                            }
                                                            onChange={(e) =>
                                                                isCheckboxChecked2(
                                                                    it.product_status_id,
                                                                    e.target.checked
                                                                )
                                                            }
                                                        >
                                                            {it.product_status_name}
                                                        </Checkbox>
                                                    </Form.Item>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                            <hr className="my-1" />
                            <div className="main_form row">
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            From Date
                                        </label>
                                        <div className="w-100">
                                            <Form.Item
                                                name="from_date"
                                                className="full_date"
                                                initialValue={moment().startOf('year').startOf('month')}
                                            >
                                                <DatePicker size="small" format={dateFormatList} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            To Date
                                        </label>
                                        <div className="w-100">
                                            <Form.Item
                                                name="to_date"
                                                className="full_date"
                                                initialValue={initialDate}
                                            >
                                                <DatePicker size="small" format={dateFormatList} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Gender
                                        </label>
                                        <div className="w-100">
                                            <Form.Item name="gender_id" initialValue={"All"}>
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null
                                                            ? optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                            : ""
                                                    }
                                                    onChange={(e, obj) => setGenderName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {gender &&
                                                        gender?.payload?.data.map((it, index) => {
                                                            return (
                                                                <Option key={index} value={it.gender_id}>
                                                                    {it.gender_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Season
                                        </label>
                                        <div className=" w-100">
                                            <Form.Item name="season_id" initialValue={"All"}>
                                                <Select
                                                    defaultValue={form.getFieldValue().season_id}
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    filterOption={(input, option) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null
                                                            ? optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                            : ""
                                                    }
                                                    onChange={(e, obj) => setSeasonName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {season &&
                                                        season?.payload?.data?.map((status, index) => {
                                                            return (
                                                                <Option key={index} value={status.season_id}>
                                                                    {status.season_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="main_form row form-margin">
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Season Year
                                        </label>
                                        <div className="w-100">
                                            <Form.Item name="new_season_year_id" initialValue={"All"}>
                                                <Select
                                                    className={"select_Inputs"}
                                                    defaultValue={form.getFieldValue().new_season_year_id}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    filterOption={(input, option) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== "All"
                                                            ? optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                            : ""
                                                    }
                                                    onChange={(e, obj) => setYearName(obj.children)}
                                                >
                                                    <Option value={"All"}>All</Option>
                                                    {seasonYear?.payload?.data?.map((res) => (
                                                        <Option
                                                            key={res.season_year_id}
                                                            value={res.season_year_id}
                                                        >
                                                            {res.season_year}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                {/*Second*/}
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Category
                                        </label>
                                        <div className="w-100">
                                            <Form.Item initialValue={"All"} name="gender_category_id">
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    onChange={(e, obj) => setCatergoryName(obj.children)}
                                                //   filterSort={(optionA, optionB) =>
                                                //     optionB?.value!==null?
                                                //       optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()):''
                                                // }
                                                >
                                                    <Option value={null}>All</Option>
                                                    {genderCategoryChange &&
                                                        genderCategoryChange?.payload?.data.length >= 0
                                                        ? genderCategoryChange &&
                                                        genderCategoryChange?.payload?.data.map(
                                                            (it, index) => {
                                                                return (
                                                                    <Option
                                                                        key={index}
                                                                        value={it.gender_category_id}
                                                                    >
                                                                        {it.gender_category_name}
                                                                    </Option>
                                                                );
                                                            }
                                                        )
                                                        : genderCategory &&
                                                        genderCategory?.payload?.data.map((it, index) => {
                                                            return (
                                                                <Option
                                                                    key={index}
                                                                    value={it.gender_category_id}
                                                                >
                                                                    {it.gender_category_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Sku
                                        </label>
                                        <div className="w-100">
                                            <Form.Item name="sku" initialValue={"All"}>
                                                <Select
                                                    notFoundContent={
                                                        Sku.loading ? (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Loader
                                                                    type="Oval"
                                                                    color="#3c4b58"
                                                                    height={20}
                                                                    width={20}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                No Data
                                                            </div>
                                                        )
                                                    }
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    onSearch={(value) => {
                                                        optimizedFn(value);
                                                    }}
                                                    optionFilterProp="children"
                                                    size="small"
                                                    onChange={(e, obj) => setSKU(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {Sku &&
                                                        Sku?.payload?.data.map((it, index) => {
                                                            return (
                                                                <Option key={index} value={it.sku}>
                                                                    {it.sku}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Style
                                        </label>
                                        <div className="w-100">
                                            <Form.Item initialValue={"All"} name="style_id">
                                                <Select
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterSort={(optionA, optionB) =>
                                                        optionB?.value !== null
                                                            ? optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                            : ""
                                                    }
                                                    size="small"
                                                    onChange={(e, obj) => setStyleName(obj.children)}

                                                >
                                                    <Option value={null}>All</Option>
                                                    {styleChange && styleChange?.payload?.data.length >= 0
                                                        ? styleChange &&
                                                        styleChange?.payload?.data.map((style, index) => {
                                                            return (
                                                                <Option key={index} value={style.style_id}>
                                                                    {style.style_name}
                                                                </Option>
                                                            );
                                                        })
                                                        : style &&
                                                        style?.payload?.data.map((style, index) => {
                                                            return (
                                                                <Option key={index} value={style.style_id}>
                                                                    {style.style_name}
                                                                </Option>
                                                            );
                                                        })}
                                                    {/* {style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })} */}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="main_form row form-margin">

                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Wash
                                        </label>
                                        <div className="w-100">
                                            <Form.Item name="wash_id" initialValue={"All"}>
                                                <Select
                                                    defaultValue={form.getFieldValue().wash_id}
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    onChange={(e, obj) => setWashName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {wash &&
                                                        wash?.payload?.data?.map((status, index) => {
                                                            return (
                                                                <Option key={index} value={status.wash_id}>
                                                                    {status.wash_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Fabric
                                        </label>
                                        <div className="w-100">
                                            <Form.Item name="fabric_id" initialValue={"All"}>
                                                <Select
                                                    defaultValue={form.getFieldValue().fabric_id}
                                                    className={"select_Inputs"}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    size="small"
                                                    onChange={(e, obj) => setFabricName(obj.children)}
                                                >
                                                    <Option value={null}>All</Option>
                                                    {fabric &&
                                                        fabric?.payload?.data?.map((status, index) => {
                                                            return (
                                                                <Option key={index} value={status.fabric_id}>
                                                                    {status.fabric_name}
                                                                </Option>
                                                            );
                                                        })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3">
                                    <div className=" d-flex flex-row align-items-baseline">
                                        <label className="labels width44" htmlFor="">
                                            Pending Till
                                        </label>
                                        <div className="w-100">
                                            <Form.Item
                                                name="as_on_date"
                                                className="full_date"
                                                initialValue={initialDate}
                                            >
                                                <DatePicker size="small" format={dateFormatList} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginTop: "3px",
                                    float: "right",
                                }}
                            >
                                {/* <label className=" no_visibility">none</label> */}
                                <Button
                                    style={{ width: "fit-content" }}
                                    type="primary"
                                    htmlType="submit"
                                    className="submit-btn-btm m-0"
                                >
                                    Generate
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            <div>
                <div

                >
                    {netShippedInventory?.payload?.data !== undefined ? (
                        data.length > 0 ? (
                            <div id="card">
                                <div style={{ display: "flex", gap: 20 }}>
                                    {genderName && <div>Gender: {genderName}11111</div>}
                                    {seasonName && <div>Season: {seasonName}</div>}
                                    {yearName && <div>Season Year: {yearName}</div>}
                                    {CatergoryName && <div>Category: {CatergoryName}</div>}
                                    {sku && <div>Sku: {sku}</div>}
                                    {styleName && <div>Style: {styleName}</div>}
                                    {washName && <div>Wash: {washName}</div>}
                                    {
                                        isChecked2.length > 0 && <div>
                                            Product Status : {filterProductStatusName && filterProductStatusName.map((val, key) => {
                                                return <span key={key}>{val.product_status_name} </span>
                                            })}
                                        </div>
                                    }

                                    <div>Pending Till: {moment(form.getFieldValue().as_on_date).format("MM-DD-YYYY")}</div>
                                </div>
                                <Table
                                    className=" border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border"
                                    ref={tableRef}
                                    size="small"
                                    bordered={false}
                                    type="company"
                                    headerClassName="abc"
                                    dataSource={data && data}
                                    columns={columns}
                                    onChange={handleTableChange}
                                    scroll={{ x: "max-content" }}
                                    loading={netShippedInventory.loading}
                                    pagination={{
                                        defaultCurrent: 1,
                                        defaultPageSize: 500,
                                        pageSizeOptions: [
                                            100, 500, 1000, 2000, 2500, 3000, 9000, 15000,
                                        ],
                                    }}
                                    summary={(pageData) => {
                                        return (
                                            <>
                                                <Table.Summary.Row>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell></Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p style={{ textAlign: "center", margin: "0" }}>
                                                            Total &gt; &gt; &gt;
                                                        </p>
                                                    </Table.Summary.Cell>

                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {shipQuantityTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            $ {shipAmountTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {returnQuantityTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            $ {returnAmountTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {netQuantityTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            $ {netAmountTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {bergenTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {trnsTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {pkTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {prodTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {pendTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {intTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {otsTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                   
                                                    <Table.Summary.Cell>
                                                        <p
                                                            style={{ textAlign: "right", margin: "0" }}
                                                            className="totalquantity"
                                                        >
                                                            {podTotal.toLocaleString("en-US")}
                                                        </p>
                                                    </Table.Summary.Cell>
                                                </Table.Summary.Row>
                                            </>
                                        );
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="no-Data">
                                <h1>No Data</h1>
                            </div>
                        )
                    ) : (
                        loading && (
                            <div className="loader" style={{ marginTop: "20px" }}>
                                <Spin size="medium" />
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default NetShippedInventory;
